export interface IApplicationProgressModel {
  status: string;
  progress: number;
}

export class ApplicationProgressModel implements IApplicationProgressModel {
  private static readonly _statusPercentMap = new Map<string, number>([
    ['draft', 20],
    ['submitted', 40],
    ['payment pending', 60],
    ['in review', 80],
    ['approved', 100]
  ]);

  private _status!: string;
  private _progress!: number;

  constructor(status: string) {
    if(status) {
      this._status = this.toTitleCase(status);
    }

    let percent = status ? ApplicationProgressModel._statusPercentMap.get(status.trim()?.toLowerCase()) : 0;
    this._progress = percent ? percent : 0;
  }

  toTitleCase(str) {
    return str.toLowerCase()
    .split(' ')
    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');
  }

  get status() {
    return this._status;
  }

  get progress() {
    return this._progress;
  }
}
